/**
 * Display-name helpers for the users surface (AUT-124).
 *
 * The server sends `displayName` already redacted-or-full per `piiRevealed`.
 * These helpers only derive avatar initials + a short id from values the
 * SPA already holds — they never reconstruct PII.
 */

/** Two-letter avatar initials from a display name; '—' fallback. */
export const initials = (displayName: string | null): string => {
  if (!displayName) return '—';
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '—';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toUpperCase();
};

/** Truncate a uuid to the mockup's `usr_8f3a…21c` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
